import git from './lib/git'
import config from './lib/config'
import cmd from './lib/cmd'
import log from './lib/log'

function preCommit() {
  if (config.git.commit.auto_stage) {
    git.addAllSync()
  }
  try {
    git.showStatusSync({ stdio: 'inherit' })
  } catch (error) {
    // do nothing
  }
}

async function prepareMessage() {
  const message = config.git.commit.message
  const options = message.map((item) => {
    const name = Object.keys(item).pop()
    const detail = item[name]
    return {
      type: 'input',
      name: name,
      message: detail.comment,
      validate: (text) => {
        if (detail.min && text.length < detail.min) {
          log.red(' <- too short')
          return false
        }
        if (detail.max && text.length > detail.max) {
          log.red(' <- too long')
          return false
        }
        return true
      },
    }
  })
  const answers = await cmd.prompt(options)
  return message
    .filter((item) => {
      const name = Object.keys(item)[0]
      return answers[name].length > 0
    })
    .map((item) => {
      const name = Object.keys(item)[0]
      const template = item[name].template
      return `${template.replace('{}', answers[name])}`
    })
    .join('\n')
}

async function commitMessage(message) {
  const answers = await cmd.promptConfirm('Make sure to commit?')
  if (answers.confirm === true) {
    try {
      git.commitMessageSync(message, { stdio: 'inherit' })
    } catch (error) {
      // do nothing
    }
  }
}

async function commit() {
  preCommit()
  const message = await prepareMessage()
  await commitMessage(message)
}

export default () => {
  commit().catch(log.catchError)
}
